import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-b8ae89cc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "login-card"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "main-content"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "main-title"
}, [/*#__PURE__*/_createElementVNode("img", {
  width: "500",
  src: "//image.zhihuishu.com/zhs/b2cm/base1/202401/7fb3191c008146ee9ce6efe0881a01e7.png"
})], -1));

const _hoisted_6 = {
  class: "login-form-box"
};
const _hoisted_7 = {
  key: 0,
  class: "login-form"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-mima1"
}, null, -1));

const _hoisted_9 = {
  class: "item-flex"
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 登录 ");

const _hoisted_11 = {
  key: 0,
  class: "change-dialog"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "验证码将会发送至您的绑定手机", -1));

const _hoisted_13 = {
  class: "reset-form"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shouji"
}, null, -1));

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-pinglun"
}, null, -1));

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-mima1"
}, null, -1));

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-mima1"
}, null, -1));

const _hoisted_18 = {
  class: "code-text"
};

const _hoisted_19 = /*#__PURE__*/_createTextVNode("获取验证码");

const _hoisted_20 = {
  key: 1,
  class: "code-get"
};
const _hoisted_21 = {
  class: "dialog-footer"
};

const _hoisted_22 = /*#__PURE__*/_createTextVNode("确认重置");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");

  const _component_el_tabs = _resolveComponent("el-tabs");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_form_item = _resolveComponent("el-form-item");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_form = _resolveComponent("el-form");

  const _component_RegisterForm = _resolveComponent("RegisterForm");

  const _component_el_dialog = _resolveComponent("el-dialog");

  const _component_Captcha = _resolveComponent("Captcha");

  return _openBlock(), _createElementBlock("div", {
    class: "login-container",
    style: _normalizeStyle({
      'background-image': $data.loginBg ? `url(${$data.loginBg})` : ''
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    height: "50",
    src: $data.logoUrl
  }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [!$data.showRegisterForm ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_form, {
    ref: "loginForm",
    model: $data.loginForm,
    rules: $data.loginRules,
    "auto-complete": "on"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tabs, {
      modelValue: $data.logInType,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.logInType = $event),
      "before-leave": $options.handlerTabs
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        label: "手机号登录",
        name: "1"
      }), _createVNode(_component_el_tab_pane, {
        label: "工号登录",
        name: "2"
      })]),
      _: 1
    }, 8, ["modelValue", "before-leave"]), _createVNode(_component_el_form_item, {
      class: "login-item",
      prop: "username"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        ref: "username",
        placeholder: $data.logInType === '2' ? '请输入工号' : '请输入手机号',
        modelValue: $data.loginForm.username,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.loginForm.username = $event),
        name: "username",
        tabindex: "1",
        type: "text",
        "auto-complete": "on",
        autocomplete: "new-password"
      }, {
        prefix: _withCtx(() => [_createElementVNode("i", {
          class: _normalizeClass(["iconfont", $data.logInType === '2' ? 'icon-gonghao' : 'icon-shouji1'])
        }, null, 2)]),
        _: 1
      }, 8, ["placeholder", "modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "login-item",
      prop: "password"
    }, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_component_el_input, {
        key: $data.passwordType,
        ref: "password",
        modelValue: $data.loginForm.password,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.loginForm.password = $event),
        type: $data.passwordType,
        placeholder: "请输入密码",
        name: "password",
        tabindex: "2",
        "auto-complete": "on",
        onKeyup: _withKeys($options.handleLogin, ["enter"])
      }, {
        prefix: _withCtx(() => [_hoisted_8]),
        _: 1
      }, 8, ["modelValue", "type", "onKeyup"]))]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "login-item"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", {
        class: "register-link",
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => $data.showRegisterForm = true, ["prevent"]))
      }, "立即注册"), _createElementVNode("div", {
        class: "reset-btn",
        onClick: _cache[4] || (_cache[4] = (...args) => $options.showReset && $options.showReset(...args))
      }, "忘记密码?")])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "login-item-third"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        onClick: _withModifiers($options.handleLogin, ["prevent"]),
        class: "login-button",
        type: "primary",
        loading: $data.loading
      }, {
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      }, 8, ["onClick", "loading"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"])])) : _createCommentVNode("", true), $data.showRegisterForm ? (_openBlock(), _createBlock(_component_RegisterForm, {
    key: 1,
    onHandleClose: _cache[5] || (_cache[5] = $event => $data.showRegisterForm = false)
  })) : _createCommentVNode("", true)])])]), $data.showResetDialog ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_dialog, {
    title: "重置密码",
    width: "400px",
    modelValue: $data.showResetDialog,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.showResetDialog = $event),
    "destroy-on-close": "",
    center: ""
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_21, [_createVNode(_component_el_button, {
      size: "large",
      type: "primary",
      onClick: $options.confirmReset
    }, {
      default: _withCtx(() => [_hoisted_22]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_hoisted_12, _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_form, {
      ref: "resetForm",
      model: $data.resetForm,
      rules: $data.resetRules,
      "auto-complete": "on"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        class: "login-item",
        prop: "phoneNumber"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          placeholder: "请输入您的手机号码",
          modelValue: $data.resetForm.phoneNumber,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.resetForm.phoneNumber = $event),
          name: "phoneNumber",
          "auto-complete": "on",
          size: "large",
          maxlength: "11"
        }, {
          prepend: _withCtx(() => [_hoisted_14]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        class: "login-item",
        prop: "code"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          class: "input-code",
          size: "large",
          modelValue: $data.resetForm.code,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.resetForm.code = $event),
          placeholder: "请输入您的手机验证码",
          autocomplete: "new-password"
        }, {
          prepend: _withCtx(() => [_hoisted_15]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        class: "login-item",
        prop: "password"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          size: "large",
          modelValue: $data.resetForm.password,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.resetForm.password = $event),
          type: "password",
          placeholder: "8-16位大小写字母和数字的新密码",
          autocomplete: "new-password"
        }, {
          prepend: _withCtx(() => [_hoisted_16]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        class: "login-item",
        prop: "copyPassword"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          size: "large",
          modelValue: $data.resetForm.copyPassword,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.resetForm.copyPassword = $event),
          type: "password",
          placeholder: "请再次输入新密码"
        }, {
          prepend: _withCtx(() => [_hoisted_17]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_18, [$data.codeShow ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "code-get",
      onClick: _cache[10] || (_cache[10] = (...args) => $options.getCode && $options.getCode(...args))
    }, [_createVNode(_component_el_button, {
      type: "text"
    }, {
      default: _withCtx(() => [_hoisted_19]),
      _: 1
    })])) : _createCommentVNode("", true), !$data.codeShow ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_el_button, {
      type: "text"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($data.count) + "秒后重新发送", 1)]),
      _: 1
    })])) : _createCommentVNode("", true)])])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_Captcha, {
    ref: "CaptchaEl",
    onSuccess: $options.captchaSuccess
  }, null, 8, ["onSuccess"])])) : _createCommentVNode("", true)], 4);
}